// services/payment.js — начинът на плащане на фактура и проформа.
//
// Промени 16.10.2026, т. 3д: полето беше свободен текст, а експортът към
// Конто решаваше „в брой или по банка" с ТОЧНО сравнение с „В брой" — „в
// брой", „Брой" или „В брой." тръгваха към Конто като банково плащане. Сега
// формата е падащо меню, сървърът нормализира написаното, а Конто разпознава
// и заварените стари текстове. Стойностите в базата остават същите думи —
// печатът и старите фактури не се пипат.

const BANK = 'По банков път';
const CASH = 'В брой';

// Падащото меню: value е думата, която се пази и печата; label е по-ясният
// надпис в менюто.
const PAYMENT_METHODS = [
  { value: BANK, label: 'По банков път (платежно нареждане)', cash: false },
  { value: CASH, label: 'В брой', cash: true },
];

// „В брой" и вариантите му — и в заварени фактури, писани на ръка.
function isCashPayment(v) {
  return /брой|cash|кеш/i.test(String(v == null ? '' : v));
}

// Нормализиране при запис: познатото става една от двете думи; друг текст
// (напр. „Прихващане", „С карта") се пази както е — за него ще има
// настройка за Конто (етап 2), не тиха подмяна.
function normalizePaymentMethod(v) {
  const s = String(v == null ? '' : v).replace(/\s+/g, ' ').trim().slice(0, 60);
  if (!s) return BANK;
  if (isCashPayment(s)) return CASH;
  if (/банк|превод|нарежд|bank|transfer/i.test(s)) return BANK;
  return s;
}

module.exports = { BANK, CASH, PAYMENT_METHODS, isCashPayment, normalizePaymentMethod };
